"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_common_icon_1 = require("@hotelplan/components.common.icon");
const components_common_label_1 = __importDefault(require("@hotelplan/components.common.label"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const Wrapper = styled_components_1.default.div({
    flex: '1',
    position: 'relative',
});
const SelectWrapper = styled_components_1.default.div({
    position: 'relative',
});
const SelectIcon = (0, styled_components_1.default)(components_common_icon_1.Icon)(({ size, theme }) => { var _a; return (_a = theme.icons) === null || _a === void 0 ? void 0 : _a[size]; }, (0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: ['14px', '20px'],
    zIndex: '1',
}));
const ChevronArrow = (0, styled_components_1.default)(components_common_icon_1.Icon).attrs({
    name: 'chevron-down',
    className: 'chevron',
})((0, util_theme_sxc_1.sx2CssThemeFn)({
    position: 'absolute',
    right: '15px',
    width: '13px',
    height: '7px',
    bottom: ['17px', '22px'],
    pointerEvents: 'none',
}));
const SelectInputWrapper = props => {
    const { name, hideLabel, label, icon, className, customLabel, children, customChevronArrow, } = props;
    return (react_1.default.createElement(Wrapper, { className: className },
        !customLabel && label ? (react_1.default.createElement(components_common_label_1.default, { htmlFor: name, hideLabel: hideLabel }, label)) : null,
        customLabel ? customLabel : null,
        icon ? (react_1.default.createElement(SelectIcon, { name: `${icon.name}`, size: icon.size, className: "status-icon" })) : null,
        react_1.default.createElement(SelectWrapper, null, children),
        customChevronArrow ? customChevronArrow : react_1.default.createElement(ChevronArrow, null)));
};
exports.default = SelectInputWrapper;
//# sourceMappingURL=SelectInputWrapper.js.map